const BASE_URL: string = window?.donationFormConfig?.backendUrl ?? '';

export default BASE_URL;
